import { render, staticRenderFns } from "./edit-bank.vue?vue&type=template&id=4b1e22fa"
import script from "./edit-bank.vue?vue&type=script&lang=js"
export * from "./edit-bank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports